import MatchedOpportunities from './MatchedOpportunities.page';

export default MatchedOpportunities;